function PrimaryAlertIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={56} height={56} fill='none'>
      <rect width={48} height={48} x={4} y={4} fill='#ECE9F2' rx={24} />
      <rect width={48} height={48} x={4} y={4} stroke='#C4BAD8' strokeWidth={8} rx={24} />
      <g clipPath='url(#a)'>
        <path
          stroke='#402080'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M28 24v4m0 4h.01M38 28c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10Z'
        />
      </g>
      <defs>
        <clipPath id='a'>
          <path fill='#fff' d='M16 16h24v24H16z' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PrimaryAlertIcon
